import { selectorFamily } from 'recoil';
import { loadCoverages } from '../../services/hippo.service';
import { getCoverageRequestItems } from '../../utils/coverablesUtil';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';

export const singleHippoCoverageTextSelector = selectorFamily({
    key: 'singleHippoCoverageTextSelector',
    get:
        ({ coverageId, termsId }: { coverageId: string; termsId: string }) =>
        async ({ get }) => {
            const topConfigContext = get(topConfigContextAtom);
            const requestItem = getCoverageRequestItems([termsId], [coverageId]);
            if (requestItem.length === 0) return [];
            return await loadCoverages(topConfigContext, requestItem);
        }
});
